import AppBar from "@mui/material/AppBar";
import { useNavigate, Outlet, useLoaderData, Navigate, useLocation } from "react-router-dom";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import CircularProgress from "@mui/material/CircularProgress";
import { Header } from "../../../components/header/Header";
import "./Home.css";
import { useUser } from "../../../contexts/UserContext";

// const drawerWidth = 240;

export const Home = () => {
  const navigate = useNavigate();
  const user = useLoaderData();
  const { pathname } = useLocation();
  const { profileComplete, completionPercent, loadingUserData, isStripeAccountVerified } = useUser();

  const newOrderPathNames = ["/home"];

  if (!user || user?.data?.role !== "user") {
    return (
      <div className="loaderParent">
        <CircularProgress />
        <Navigate to="/login" replace={true} />
      </div>
    );
  }

  // Pages where profile completion banner should be visible
  const showProfileBannerOnPages = [
    "/home",
    "/home/available-berths",
    "/home/create-berth"
  ];
  const shouldShowProfileBanner = !loadingUserData && !profileComplete && showProfileBannerOnPages.includes(pathname);

  // Pages where Stripe setup banner should be visible
  const showStripeBannerOnPages = [
    "/home/available-berths",
    "/home/create-berth"
  ];
  const shouldShowStripeBanner = !loadingUserData && profileComplete && !isStripeAccountVerified && showStripeBannerOnPages.includes(pathname);

  return (
    <div className="dashbaord-page">
      <Header user={user} />
      <div className="page-container">
        <Box className="tabs-container">
          <Container maxWidth="xl">
            <AppBar position="static" className="subNav">
              <div className="nav-tab">
                {/* <IconButton edge="start" color="inherit" aria-label="menu"></IconButton>
                <Typography variant="h6" className={classes.title}></Typography> */}
                <Button
                  className={[
                    newOrderPathNames.includes(pathname)
                      ? "nav-link active"
                      : "nav-link",
                  ]}
                  onClick={() => navigate("")}
                  color="inherit"
                >
                  Dashboard
                </Button>
                <Button
                  className={[
                    pathname === "/home/available-berths"
                      ? "nav-link active"
                      : "nav-link",
                  ]}
                  onClick={() => navigate("available-berths")}
                  color="inherit"
                >
                  Available Berths
                </Button>
                <Button
                  className={[
                    pathname === "/home/create-berth"
                      ? "nav-link active"
                      : "nav-link",
                  ]}
                  onClick={() => navigate("create-berth")}
                  color="inherit"
                >
                  List your berth
                </Button>
                <Button
                  className={[
                    pathname === "/home/past-berths"
                      ? "nav-link active"
                      : "nav-link",
                  ]}
                  onClick={() => navigate("past-berths")}
                  color="inherit"
                >
                  Past Berths
                </Button>
              </div>
            </AppBar>
          </Container>
        </Box>
        <Box className="page-content">
          <Container maxWidth="xl">
            {/* Profile Completion Banner */}
            {shouldShowProfileBanner && (
              <Alert
                severity="warning"
                sx={{ mb: 2, mt: 0, fontSize: 12, alignItems: "center" }}
                action={
                  <Button
                    color="inherit"
                    size="small"
                    variant="outlined"
                    onClick={() => navigate("profile")}
                    sx={{
                      width: {xs: 100, sm: 120, md: 140},
                      mr: {xs: 0, sm: 1, md: 2},
                      fontWeight: 600,
                      fontSize: {xs: 10, sm: 11, md: 12},
                      borderColor: 'rgba(255, 152, 0, 0.5)',
                      '&:hover': {
                        borderColor: 'rgba(255, 152, 0, 0.8)',
                        backgroundColor: 'rgba(255, 152, 0, 0.1)'
                      }
                    }}
                  >
                    Complete Now
                  </Button>
                }
              >
                <AlertTitle fontSize={{xs: 13, sm: 14, md: 15}} sx={{ fontWeight: 600 }}>
                  Profile Incomplete
                </AlertTitle>
                {/* Complete your profile to access all features including <strong>creating berth</strong> listings.
                We need your yacht specifications and captain information. */}
                Complete your profile to access the full Mooringmate experience.
              </Alert>
            )}

            {/* Stripe Account Setup Banner */}
            {shouldShowStripeBanner && (
              <Alert
                severity="info"
                sx={{ mb: 2, mt: 0, fontSize: 12, alignItems: "center" }}
                action={
                  <Button
                    color="inherit"
                    size="small"
                    variant="outlined"
                    onClick={() => navigate("payment-account")}
                    sx={{
                      width: {xs: 100, sm: 120, md: 140},
                      mr: {xs: 0, sm: 1, md: 2},
                      fontWeight: 600,
                      fontSize: {xs: 10, sm: 11, md: 12},
                      borderColor: 'rgba(2, 136, 209, 0.5)',
                      '&:hover': {
                        borderColor: 'rgba(2, 136, 209, 0.8)',
                        backgroundColor: 'rgba(2, 136, 209, 0.1)'
                      }
                    }}
                  >
                    Setup Now
                  </Button>
                }
              >
                <AlertTitle fontSize={{xs: 13, sm: 14, md: 15}} sx={{ fontWeight: 600 }}>
                  Stripe Account Required
                </AlertTitle>
                Connect your Stripe account to receive payments for berth rentals and enable listing features.
              </Alert>
            )}

            <Outlet />
          </Container>
        </Box>
      </div>
    </div>
  );
};
